import { createTranslations } from '@npco/utils-translations'

export const outstandingExpensesTranslations = createTranslations({
  title: 'Required Information',
  description:
    'Select below what information needs to be supplied with each card transaction. All transactions without this information will be marked as Outstanding.',
})
